import { ModelError_Response } from '@treadinc/horizon-api-spec';
import { isAxiosError } from 'axios';

export default function readVetaCenterRejection(error: unknown) {
  const rejected = isAxiosError<ModelError_Response>(error)
    ? error.response?.data?.error?.errors?.[0]
    : undefined;

  return { field: rejected?.field, message: rejected?.message };
}
